import React, {useEffect} from 'react'
import Slider from 'react-slick';
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import HomePageData from './home-data';
import { Link } from 'react-router-dom';

function OurStories() {

    
    useEffect(() => {
        AOS.init({
            once:true,
        });
      }, [])

    const settings = {
        infinite: false,
        speed: 1000,
        arrows: false,
        slidesToShow: 4,
        autoplay: false,
        dots: false,
        autoplaySpeed: 2000,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                adaptiveHeight: true,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
        ],
    };
  return (
    <>
        <section className='our-stories'>
            <div className='container'>
                <div className='top-head'>
                    <h3 className='ttl1'>Insights and Resources</h3>
                </div>
                </div>
            <div className='stories-flex'>
                    <Slider {...settings} className='stories-slider'>
                        {HomePageData.StoriesCaseStudies.map((response, index) => (
                            <div className='inr-cont' key={index}>
                                <img src={response.csImg} alt="" width={"330"} height={"596"} />
                                <div className='cont-desc'>
                                    <h4>{response.csHeading}</h4>
                                    <p className='sm-para'>{response.csDescription}</p>
                                    <Link to={response.csBtnLink} className='btn'><span>{response.csBtnText}</span></Link>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
                
        </section>

       
    </>

  )
}

export default OurStories;
